const THREAD_ARCHIVE_NOT_FOUND_CODE = 'THREAD_ARCHIVE_NOT_FOUND';

/**
 * True when an archive request failed because the thread no longer exists
 * server-side, so the optimistic removal should stay instead of being restored.
 */
const isThreadArchiveAlreadyGoneFailure = (payload = {}) => {
  const failureCode = String(payload?.code || '').trim();

  if (failureCode === THREAD_ARCHIVE_NOT_FOUND_CODE) {
    return true;
  }

  const failureStatus = Number(payload?.status);

  return Number.isFinite(failureStatus) && failureStatus === 404;
};

export default isThreadArchiveAlreadyGoneFailure;
